module.exports = __webpack_public_path__ + "static/media/ic-redeem.f4383027.svg";